import { render, staticRenderFns } from "./XinLvAdd.vue?vue&type=template&id=076a520f&scoped=true&"
import script from "./XinLvAdd.vue?vue&type=script&lang=js&"
export * from "./XinLvAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a520f",
  null
  
)

export default component.exports